/**
 * MED-1346: 1:1 miss claims. A claim records a no-show or a late change
 * (under 24 hours' notice) that Medley pays the coach for, at most twice on
 * each 1:1. Intro and midpoint check-ins never have claims.
 */

import apiClient from './client';
import type { MissClaim, MissClaimKind } from '../../types';

export const missClaimsApi = {
  /** The coach's own claims that wait for an answer. */
  listPending: (): Promise<{ claims: MissClaim[] }> =>
    apiClient.get('/api/coach/miss-claims?decision=pending'),

  /** Every claim of one 1:1, and how many of them are paid. Session coach or staff. */
  listForSession: (
    cohortId: string,
    sessionId: string
  ): Promise<{ claims: MissClaim[]; paidMissCount: number }> =>
    apiClient.get(`/api/cohorts/${cohortId}/sessions/${sessionId}/miss-claims`),

  /** Answers a pending claim. True pays it (within the cap); false declines it. 409 when not pending. */
  answer: (
    cohortId: string,
    sessionId: string,
    claimId: string,
    underTwentyFourHours: boolean
  ): Promise<{ claim: MissClaim }> =>
    apiClient.post(
      `/api/cohorts/${cohortId}/sessions/${sessionId}/miss-claims/${claimId}/answer`,
      { underTwentyFourHours }
    ),

  /** Staff only: flags a late change the system did not see. 409 when one exists for that start. */
  flag: (
    cohortId: string,
    sessionId: string,
    data: { kind: MissClaimKind; originalStart: string; changeAt?: string }
  ): Promise<{ claim: MissClaim }> =>
    apiClient.post(
      `/api/cohorts/${cohortId}/sessions/${sessionId}/miss-claims`,
      data
    ),
};
